export default "/images/tinder-logo.png?e050734179c02fc9dd45b91fceaa2edf";